import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckoutDataAccessModule } from '@checkout/data-access';
import { CheckoutFeatureModule } from '@checkout/feature';
import { CheckoutPageComponent, CheckoutUiModule, OrderConfirmationPageComponent } from '@checkout/ui';
import { OrderShellModule } from '@order/shell';
import { seoPageResolver } from '@seo/feature';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: CheckoutPageComponent,
    resolve: {
      seoPage: seoPageResolver('checkout'),
    },
  },
  {
    path: 'order-confirmation',
    pathMatch: 'full',
    component: OrderConfirmationPageComponent,
    data: { semanticName: 'order-confirmation' },
    resolve: {
      seoPage: seoPageResolver('order-confirmation'),
    },
  },
  {
    path: '',
    redirectTo: '/not-found',
  },
];
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CheckoutUiModule,
    CheckoutDataAccessModule,
    CheckoutFeatureModule,
    OrderShellModule,
  ],
})
export class CheckoutShellModule {}
